import { CpdsBreadcrumbs } from './cdps-breadcrumb';
import { Viewport, ViewportSmall, ViewportMedium, ViewportLarge, ViewportExtraLarge } from './cpds-viewport';
import CpdsButton from './cpds-button';
import CpdsSeparatorLine from './cpds-separator-line';
import CpdsCaptions from './cpds-captions';
import CpdsDropDown from './cpds-drop-down';
import CpdsGrid from './cpds-grid';
import CpdsGridItem from './cpds-grid-item';
import CpdsIcon from './cpds-icon';
import CpdsTags from './cpds-tag';
import CpdsSponsorTag from './cpds-sponsor-tag';
import * as CpdsTab from './cpds-tab';
import CpdsScrollbar from './cpds-scrollbar';
import CpdsAccordion from './cpds-accordion';
import CpdsSectionTitle from './cpds-section-title';
import CpdsProgressBar from './cpds-progress-bar';
import CpdsDottedPagination from './cpds-dotted-pagination';
import CpdsRatings from './cpds-ratings';
import CpdsBreakerQuote from './cpds-breaker-quote';
import CpdsSubtitleParagraph from './cpds-subtitle-paragraph';
import { CpdsInputs } from './cpds-input-fields';
import CpdsElevation from './cpds-elevation';
import CpdsMagazineNameplate from './cpds-magazine-nameplate';
import CpdsLogo from './cpds-logo';
import CpdsImage from 'components/common/cpds/cpds-image';
import Layout from 'src/components/common/theme/Layout';
import CpdsCopyright from './cpds-copyright';
import CpdsGridPlaceholder from './cpds-grid-placeholder';
// import { CpdsCard } from './cpds-card';
import * as CpdsCard from './cpds-cards-v2';
import CpdsBoxLayout from "components/common/cpds/cpds-box-layout";
import CpdsDatepicker from './cpds-datepicker';
import CpdsVideoPlayButton from "components/common/cpds/cpds-video-play-button";
import { CpdsSweepstakesFormsToolkitsInputs } from './cpds-sweepstakes-forms-toolkits-inputs';
import CpdsTranspoter from './cpds-transpoter';
import CpdsInlinePullQuote from './cpds-inline-pull-quote';
import CpdsVideo from './cpds-video';

export const Cpds = {
  BreadCrumbs: CpdsBreadcrumbs,
  SeparatorLine: CpdsSeparatorLine,
  Button: CpdsButton,
  DropDown: CpdsDropDown,
  Viewport,
  ViewportSmall,
  ViewportMedium,
  ViewportLarge,
  ViewportExtraLarge,
  Captions: CpdsCaptions,
  GridContainer: CpdsGrid,
  GridItem: CpdsGridItem,
  Icon: CpdsIcon,
  Tag: CpdsTags,
  SponsorTag: CpdsSponsorTag,
  SectionTitle: CpdsSectionTitle,
  Tab: CpdsTab,
  scrollBar: CpdsScrollbar,
  Accordion: CpdsAccordion,
  ProgressBar: CpdsProgressBar,
  DottedPagination: CpdsDottedPagination,
  Ratings: CpdsRatings,
  BreakerQuote: CpdsBreakerQuote,
  SubtitleParagraph: CpdsSubtitleParagraph,
  Inputs: CpdsInputs,
  Image: CpdsImage,
  Elevation: CpdsElevation,
  MagazineNameplate: CpdsMagazineNameplate,
  Logo: CpdsLogo,
  Layout: Layout,
  Copyright: CpdsCopyright,
  GridPlaceholder: CpdsGridPlaceholder,
  Card: CpdsCard,
  BoxLayout: CpdsBoxLayout,
  DatePicker: CpdsDatepicker,
  PlayButton: CpdsVideoPlayButton,
  SweepstakesFormsToolkitsInputs: CpdsSweepstakesFormsToolkitsInputs,
  Transpoter: CpdsTranspoter,
  InlinePullQuote: CpdsInlinePullQuote,
  Video: CpdsVideo
};
